<template>
  <div class="c-section-loader">
    <transition name="fade">
      <div class="c-section-loader__loader" v-if="showLoading">
        <h2>
          {{ message }}
        </h2>
      </div>
    </transition>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "section-loader",
  data: function () {
    return {
      fadeDelay: null,
      showLoading: false,
    };
  },
  props: {
    "is-loading": {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: "Loading ...",
    },
    delay: {
      type: Number,
      default: 200,
    },
  },
  mounted: function () {
    this.showLoading = this.isLoading;
  },
  watch: {
    isLoading: function (state) {
      let _this = this;
      if (state === true) {
        this.showLoading = state;
      } else {
        clearTimeout(this.fadeDelay);
        this.fadeDelay = setTimeout(function () {
          _this.showLoading = state;
        }, _this.delay);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.c-section-loader {
  .c-section-loader__loader {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1000;
    background-color: rgba($color: #fff, $alpha: 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
}
</style>
